import React from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import classes from "classnames";

import RichTextBlock from "./RichTextBlock";

import "../styles/components/MarketingCopy.scss";

const MarketingCopy = ({ copy, classNames }) => {
    if (!copy) return null;

    return (
        <div className={classes("marketing-copy d-flex", classNames)}>
            <div className="copy">
                <RichTextBlock content={copy} />
            </div>
        </div>
    );
};

MarketingCopy.propTypes = {
    classNames: PropTypes.string,
    copy: PropTypes.shape({ raw: PropTypes.string.isRequired }),
};

export const query = graphql`
    fragment DynamicMarketingCopy on ContentfulMarketingCopy {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        classNames
        copy: marketingCopy {
            raw
            references {
                ... on ContentfulFrame {
                    __typename
                    contentful_id
                    title
                    url
                    hide
                    mobileImage {
                        gatsbyImageData(layout: CONSTRAINED)
                        title
                        description
                        file {
                            contentType
                            url
                        }
                    }
                }
                ... on ContentfulAsset {
                    __typename
                    contentful_id
                    file {
                        contentType
                        url
                    }
                    title
                    description
                }
            }
        }
    }
`;

export default MarketingCopy;
